var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTileMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "26px",
    viewBox: "0 0 22 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9159026C-E4AF-4B9B-A6E0-B8C52E30AA57") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-1187.000000, -3673.000000)",
    fill: "#464646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(1187.000000, 3673.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,24 L10,25 C10,25.5522847 9.55228475,26 9,26 L1,26 C0.44771525,26 6.76353751e-17,25.5522847 0,25 L0,24 L10,24 Z M22,24 L22,25 C22,25.5522847 21.5522847,26 21,26 L13,26 C12.4477153,26 12,25.5522847 12,25 L12,24 L22,24 Z M8.4,14 C9.22842712,14 9.9,14.6715729 9.9,15.5 L9.9,23 L0,23 L0,15.5 C3.42636147e-16,14.6715729 0.671572875,14 1.5,14 L8.4,14 Z M20.5,14 C21.3284271,14 22,14.6715729 22,15.5 L22,23 L12.1,23 L12.1,15.5 C12.1,14.6715729 12.7715729,14 13.6,14 L20.5,14 Z M10,10 L10,11 C10,11.5522847 9.55228475,12 9,12 L1,12 C0.44771525,12 6.76353751e-17,11.5522847 0,11 L0,10 L10,10 Z M22,10 L22,11 C22,11.5522847 21.5522847,12 21,12 L13,12 C12.4477153,12 12,11.5522847 12,11 L12,10 L22,10 Z M8.4,0 C9.22842712,-1.52179594e-16 9.9,0.671572875 9.9,1.5 L9.9,9 L0,9 L0,1.5 C3.42636147e-16,0.671572875 0.671572875,1.52179594e-16 1.5,0 L8.4,0 Z M20.5,0 C21.3284271,-1.52179594e-16 22,0.671572875 22,1.5 L22,9 L12.1,9 L12.1,1.5 C12.1,0.671572875 12.7715729,1.52179594e-16 13.6,0 L20.5,0 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileMedium);
export default __webpack_public_path__ + "static/media/TileMedium.32858ec87bb41a55a2dc17d8fbac6aa9.svg";
export { ForwardRef as ReactComponent };